/** Zestawy kolorystyczne do wyboru w ustawieniach */

export const COLOR_SCHEMES = [
  {
    id: 'default',
    label: 'Domyślny (obecny)',
    description: 'Zielonkawo-szary, spokojny',
    colors: {
      primary: '#2C4A52',
      primaryHover: '#1e343a',
      accent: '#8E9775',
      background: '#F4F7F5',
    },
    swatches: ['#2C4A52', '#8E9775', '#F4F7F5', '#1e343a'],
  },
  {
    id: 'interior',
    label: 'Interior',
    description: 'Biel, szarości, brąz, grafit',
    colors: {
      primary: '#3C3C3C',
      primaryHover: '#2a2a2a',
      accent: '#8B7355',
      background: '#F5F4F0',
    },
    swatches: ['#FFFFFF', '#E8E6E2', '#8B7355', '#3C3C3C'],
  },
  {
    id: 'psychology',
    label: 'Psychologia',
    description: 'Błękity, teal, pomarańczowy akcent',
    colors: {
      primary: '#297194',
      primaryHover: '#1f5569',
      accent: '#EC993D',
      background: '#E7F2F7',
    },
    swatches: ['#E7F2F7', '#D1E1F7', '#297194', '#EC993D'],
  },
  {
    id: 'thriveworks',
    label: 'Thriveworks',
    description: 'Kremowy, żółty, zielony, ciemny niebieski',
    colors: {
      primary: '#14467C',
      primaryHover: '#0f3459',
      accent: '#52B774',
      background: '#F8F5EE',
    },
    swatches: ['#F8F5EE', '#F9CC48', '#52B774', '#14467C'],
  },
  {
    id: 'carolina',
    label: 'Carolina Blue',
    description: 'Chinese Black, Carolina Blue, Bright Gray',
    colors: {
      primary: '#121310',
      primaryHover: '#0a0908',
      accent: '#5E9BD9',
      background: '#E8EEF6',
    },
    swatches: ['#121310', '#5E9BD9', '#E8EEF6'],
  },
];
